import Axios from "axios";
import { customerProfileAccountsUrl, customerProfileSamUrl, customerProfileSamRecordUrl, customerProfileLeadMatchUrl, customerProfileLeadConvertUrl } from "@/store/module/customerProfile/api";

const state = {
  customerProfileSam: null,
  customerProfileAccounts: [],
};

const getters = {
  getCustomerProfileSam: (state) => state.customerProfileSam,
  getCustomerProfileAccounts: (state) => state.customerProfileAccounts,
};

const mutations = {
  SET_CUSTOMER_PROFILE_SAM(state, data) {
    state.customerProfileSam = data;
  },
  UNSET_CUSTOMER_PROFILE_SAM(state) {
    state.customerProfileSam = null;
  },
  SET_CUSTOMER_PROFILE_ACCOUNTS(state, data) {
    state.customerProfileAccounts = data;
  },
};

const actions = {
  fetchCustomerProfileAccounts({ commit }, params = {}) {
    return Axios.get(customerProfileAccountsUrl, { params: { per_page: 100, ...params } })
      .then((response) => {
        commit("SET_CUSTOMER_PROFILE_ACCOUNTS", response.data.data || []);
        return response;
      });
  },
  fetchCustomerProfileSam({ commit }, customerId) {
    return Axios.get(customerProfileSamUrl(customerId))
      .then((response) => {
        commit("SET_CUSTOMER_PROFILE_SAM", response.data.data);
        return response;
      })
      .catch((error) => {
        commit("UNSET_CUSTOMER_PROFILE_SAM");
        throw error;
      });
  },
  saveCustomerProfileSam({ dispatch }, { customerId, data }) {
    return Axios.put(customerProfileSamUrl(customerId), data)
      .then((response) => dispatch("fetchCustomerProfileSam", customerId).then(() => response));
  },
  saveCustomerProfileSamRecord({ dispatch }, { customerId, type, data }) {
    return Axios.post(customerProfileSamRecordUrl(customerId, type), data)
      .then((response) => dispatch("fetchCustomerProfileSam", customerId).then(() => response));
  },
  matchCustomerProfileLead(context, leadId) {
    return Axios.post(customerProfileLeadMatchUrl(leadId));
  },
  convertCustomerProfileLead(context, { leadId, data }) {
    return Axios.post(customerProfileLeadConvertUrl(leadId), data);
  },
};

export default { state, getters, mutations, actions };
